module.exports = __webpack_public_path__ + "static/media/Feedbackbg@3x.1d83a389.png";